// GENERATED by scripts/gen-site-counts.mjs. Do not edit by hand.
// Re-run `npm run gen:counts` after adding content to a registry.
export const SITE_COUNTS = {
  "articles": 264,
  "helpArticles": 122,
  "guides": 31,
  "caseStudies": 15,
  "competitors": 33,
  "alternatives": 7,
  "freeTools": 38,
  "platforms": 10,
  "playbooks": 3,
  "downloads": 23,
  "glossary": 132
} as const
